module.exports = __webpack_public_path__ + "img/budget.898d827f.png";